import { CloseIcon } from 'src/components/icons/CloseIcon'
import FastPickupIcon from 'src/components/icons/store/FastPickupIcon'
import FavouriteStoreIcon from 'src/components/icons/store/FavouriteStoreIcon'
import ServicesIcon from 'src/components/icons/store/ServicesIcon'
import type { FavouriteStore } from 'src/components/sections/Store/typings'
import { getStoreAddress, getStoreName } from './utils/utils'

type FavouriteStoreModalProps = {
  favouriteStore: FavouriteStore | null
  closeModal: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  openSidebar?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  confirmStore?: () => void
  isClosing?: boolean
  pickingTime?: number
  isMobile?: boolean
}

const FavouriteStoreModal = ({
  favouriteStore,
  closeModal,
  openSidebar,
  pickingTime,
  isMobile,
}: FavouriteStoreModalProps) => {
  return (
    <div
      className={`max-w-[500px] absolute flex flex-col  bg-white rounded-lg shadow-[0px_0px_16px_2px_rgba(0,0,0,0.35)] overflow-hidden dropdown-subheader-body ${
        isMobile
          ? 'opacity-100 z-[3] left-0 p-4 top-[35px] gap-3'
          : 'opacity-0 -z-1 left-10 p-6 top-[52px] gap-4'
      }`}
    >
      {favouriteStore ? (
        <>
          <div className="flex gap-4 items-center">
            <FavouriteStoreIcon
              width={isMobile ? 20 : 24}
              height={isMobile ? 20 : 24}
              className="shrink-0"
            />
            <div
              className={`font-semibold ${
                isMobile ? 'text-base leading-tight' : 'text-lg'
              } `}
            >
              È questo il tuo negozio preferito?
            </div>
            <button
              onClick={(e) => closeModal(e)}
              aria-label="Chiudi modale"
              className="p-0 bg-transparent outline-none cursor-pointer ml-auto"
            >
              <CloseIcon
                width={isMobile ? 20 : 24}
                height={isMobile ? 20 : 24}
                className="shrink-0"
              />
            </button>
          </div>
          <div className="flex flex-col gap-[2px]">
            <div className="font-semibold">
              {getStoreName(favouriteStore, 'summary')}
            </div>
            <div className="text-xs uppercase font-normal">
              {getStoreAddress(favouriteStore)}
            </div>
          </div>
          <div className="flex items-center justify-between gap-4 mt-1">
            <button
              onClick={openSidebar}
              className={`bg-transparent outline-none cursor-pointer underline p-0 font-semibold ${
                isMobile ? 'text-xs' : 'text-sm'
              }`}
            >
              Scegli un altro negozio
            </button>
            <button
              onClick={(e) => closeModal(e)}
              className={`bg-yellow rounded-md cursor-pointer flex items-center justify-center py-2 px-4 w-[150px] font-semibold ${
                isMobile ? 'text-xs' : 'text-sm'
              }`}
            >
              {/* {isClosing ? (
                <div className="border-4 rounded-full animate-spin border-black w-5 h-5"></div>
              ) : ( */}
              Sì, è questo
              {/* )} */}
            </button>
          </div>
        </>
      ) : (
        !isMobile && (
          <>
            <div className="flex gap-4 items-center">
              <FavouriteStoreIcon className="shrink-0" />
              <div className="font-semibold text-lg">
                Seleziona il tuo negozio preferito
              </div>
              <button
                onClick={closeModal}
                aria-label="Chiudi modale"
                className="p-0 bg-transparent outline-none cursor-pointer ml-4"
              >
                <CloseIcon className="shrink-0" />
              </button>
            </div>
            <div className="flex gap-4 items-center">
              <FastPickupIcon className="shrink-0" />
              <div className="flex flex-col gap-[2px] mt-1">
                <div className="font-semibold">Stock in tempo reale</div>
                <div className="text-xs font-normal">
                  Verifica la disponibilità per il ritiro in negozio anche in{' '}
                  <span className="text-[#0f6b34] font-semibold">
                    {pickingTime} {pickingTime === 1 ? 'ora' : 'ore'}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <ServicesIcon className="shrink-0" />
              <div className="flex flex-col gap-[2px]">
                <div className="font-semibold">Prenotazione servizi</div>
                <div className="text-xs font-normal">
                  Scopri i servizi disponibili nel tuo store preferito e
                  prenotali
                </div>
              </div>
            </div>
            <button
              onClick={openSidebar}
              className="rounded-md mt-2 bg-yellow cursor-pointer flex items-center justify-center font-semibold py-3 px-4 w-full"
            >
              Seleziona negozio
            </button>
          </>
        )
      )}
    </div>
  )
}

export default FavouriteStoreModal
